export default {
  parkingFines: [],
  selectedParkingFine: undefined,
  parkingFineImages: [],
  availableReasons: [],
  parkingStatusCheckLogs: [],
  parkingFineReportingTasks: [],
  selectedParkingFineReportingTask: undefined,
  enforcementOfficers: [],
  selectedEnforcementOfficer: undefined,
  enforcementPlaceGroups: []
}
